import React from "react";
import { Skeleton, Card } from "antd";

const LoginSkeleton = () => {
  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div style={{ width: 500, display: "flex", flexDirection: "column" }}>
        <Skeleton.Input active style={{ width: "100%", marginBottom: 16 }} />
        <Skeleton.Input active style={{ width: "100%", marginBottom: 16 }} />
        <Skeleton.Input active style={{ width: "100%" }} />
      </div>
    </div>
  );
};

export default LoginSkeleton;
